import {useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {useFetch} from "../../../../../../services/useFetch";
import {API_CONTRACT_NON_EMPLOYEE} from "../../../../../../services/apiContractNonEmployee";
import {constructOptionsSelect, convertArrayToObject, deepClone, formatDateMoment} from "../../../../../../utils/utils";
import {setContractDetail, setOptions} from "../../../../../../reducers/contractReducer";
import {FORM_ADDENDUM_CONTRACT_NON_EMPLOYEE, FORM_CREATE_CONTRACT_NON_EMPLOYEE} from "../../../../../../constants/constant-management-contract";
import {FormContractNonEmployeeContainer} from "../../../../form-contract/FormContractNonEmployeeContainer";
import {Alert} from "../../../../../../components/commons/alert";

export const EditContractContainer = () => {
    const [searchParams] = useSearchParams();
    const contractId = searchParams.get('contractId')
    const employeeId = searchParams.get('employeeId')
    const dispatch = useDispatch()
    const {contractDetail} = useSelector(state => state.contractReducer)
    const [form, setForm] = useState([])
    const [errorForm, setErrorForm] = useState({})
    const {fetching: getContractDetailApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.DETAIL_CONTRACT)
    const {fetching: getJobTitleByCompanyApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.LIST_JOB_TITLE)
    const {fetching: getCompanyListApi} = useFetch({...API_CONTRACT_NON_EMPLOYEE.LIST_COMPANY, initPathVariable: employeeId})
    const {fetching: getConstantApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.CONSTANT)
    const {fetching: editContractApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.EDIT_CONTRACT)
    const {fetching: getGradeByJobTitleApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.LIST_GRADE)

    useEffect(() => {
        Promise.all([getConstantApi(), getCompanyListApi()])
            .then(result => {
                let ptkp_status = constructOptionsSelect(result[0].data.ptkp_status)
                let company = constructOptionsSelect(result[1].data, 'name', 'company_id')
                dispatch(setOptions({ptkp_status, company}))
            })
    }, []);

    useEffect(() => {
        getContractDetailApi({}, contractId)
            .then(res => {
                let company = constructOptionsSelect([res.data.company], 'name', 'id')
                let job_title = constructOptionsSelect([res.data.job_title], 'name', 'id')
                let grade = constructOptionsSelect([res.data.grade], 'name', 'id')
                let ptkp_status = constructOptionsSelect([res.data.ptkp_status])
                let defineForm = res?.data?.addendum_start_date ? FORM_ADDENDUM_CONTRACT_NON_EMPLOYEE : FORM_CREATE_CONTRACT_NON_EMPLOYEE
                constructAllowance(res.data.allowances, defineForm)
                dispatch(setContractDetail({
                    ...res.data,
                    company: company[0],
                    job_title: job_title[0],
                    grade: grade[0],
                    ptkp_status: ptkp_status[0],
                }))
                getJobTitle(company[0].value)
                getGrade(job_title[0].value)
            })
    }, []);

    const constructAllowance = (allowances, defineForm) => {
        let copyForm = deepClone(defineForm)
        let copyFormSalary = deepClone(defineForm[defineForm.length - 1].form)
        copyForm[defineForm.length - 1].form = copyFormSalary.concat(allowances)
        setForm(copyForm)
    }

    const getJobTitle = (companyId) => {
        getJobTitleByCompanyApi({companyId}, employeeId)
            .then(result => {
                dispatch(setOptions({job_title: constructOptionsSelect(result.data, 'title', 'id')}))
            })
    }

    const getGrade = (jobTitleId) => {
        getGradeByJobTitleApi({jobTitleId})
            .then(result => {
                dispatch(setOptions({grade: constructOptionsSelect(result.data, 'name', 'id')}))
            })
    }

    const onSubmitForm = (notes) => {
        let requestBody = {
            is_interim: contractDetail?.is_interim,
            nip: contractDetail.nip,
            addendum_number: contractDetail.addendum_number,
            company_id: contractDetail.company.value,
            job_title_id: contractDetail.job_title.value,
            grade_id: contractDetail.grade.value,
            type: contractDetail.type,
            ptkp_status: contractDetail.ptkp_status.value,
            end_date: formatDateMoment(contractDetail.end_date, 'YYYY-MM-DD'),
            base_salary: contractDetail.base_salary,
            job_description: contractDetail.job_description,
            notes
        }

        if (!contractDetail.addendum_number) {
            requestBody.number = contractDetail.number
            requestBody.start_date = formatDateMoment(contractDetail.start_date, 'YYYY-MM-DD')
        } else {
            requestBody.addendum_start_date = formatDateMoment(contractDetail.addendum_start_date, 'YYYY-MM-DD')
            requestBody.addendum_end_date = formatDateMoment(contractDetail.addendum_end_date, 'YYYY-MM-DD')
        }

        editContractApi(requestBody, contractId)
            .then(res => {
                Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Edit Kontrak Berhasil!',
                })
                window.location.href = `/non-employee-worker/non-employee-contract-detail?contractId=${contractId}`
            })
            .catch(err => {
                if (err.code === '422') {
                    setErrorForm(convertArrayToObject(err.data))
                }
            })
    }

    let props = {
        onSubmitForm,
        activity: 'edit',
        form,
        errorForm
    }

    return (
        <FormContractNonEmployeeContainer {...props} />
    )
}
